<div class="mt-5 mb-2 flex">
  <div class="font-bold text-xl">{{'handover.comments' |translate}}</div>
</div>
<div *ngIf="model?.comments else elseTemp">
  <handoverm-handover-section *ngFor="let comment of model?.comments" [desc]="comment.desc"
                              [images]="comment.imageUrls" [model]="model"></handoverm-handover-section>
</div>
<ng-template #elseTemp>
  <div class="tk-border-gray-2 px-5 py-4 rounded-xl">
    {{'handover.no-comments' | translate}}
  </div>
</ng-template>
